// config.ts
import { Config } from "@adornis/config/config.js";
var livekitConfig = new Config("livekit", {
  apiKey: {
    env: true,
    name: "LIVEKIT_API_KEY",
    client: false,
    required: true
  },
  apiSecret: {
    env: true,
    name: "LIVEKIT_API_SECRET",
    client: false,
    required: true
  },
  serverDomain: {
    env: true,
    name: "LIVEKIT_SERVER_DOMAIN",
    client: true,
    required: true
  }
});
export {
  livekitConfig
};
